export default __webpack_public_path__ + "static/media/cancel-payment-source.e28aeb37.png";